import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { SharedModule } from '../shared/shared.module';
import { UserlistComponent } from '../userlist/userlist.component';
import { ColormanagementComponent } from '../colormanagement/colormanagement.component';
import { ModelmanagementComponent } from '../modelmanagement/modelmanagement.component';
import { PlanComponent } from '../plan/plan.component';
import { MasterComponent } from '../master/master.component';
import { PolicymasterComponent } from '../policymaster/policymaster.component';
import { NxCardModule } from '@allianz/ng-aquila/card';
import { NxLinkModule } from '@allianz/ng-aquila/link';
import { NxGridModule } from '@allianz/ng-aquila/grid';
import { NxFormfieldModule } from '@allianz/ng-aquila/formfield';
import { NxInputModule } from '@allianz/ng-aquila/input';
import { NxDropdownModule } from '@allianz/ng-aquila/dropdown';
import { NxPopoverModule } from '@allianz/ng-aquila/popover';
import { NxIconModule } from '@allianz/ng-aquila/icon';
import { NxLabelModule, NxErrorModule } from '@allianz/ng-aquila/base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NxButtonModule } from '@allianz/ng-aquila/button';
import { NxTabsModule } from '@allianz/ng-aquila/tabs';
import { NxTableModule } from '@allianz/ng-aquila/table';
import { NxBadgeModule } from '@allianz/ng-aquila/badge';
import { NxSwitcherModule } from '@allianz/ng-aquila/switcher';
import { NxModalModule } from '@allianz/ng-aquila/modal';
import { NxDatefieldModule } from '@allianz/ng-aquila/datefield';
import { NxNativeDateModule } from '@allianz/ng-aquila/datefield';
import { NxMomentDateModule } from '@allianz/ng-aquila/moment-date-adapter';
import { NxSpinnerModule } from '@allianz/ng-aquila/spinner';
import { NxPaginationModule } from '@allianz/ng-aquila/pagination';
import { NxMessageModule } from '@allianz/ng-aquila/message';
import { NxCopytextModule } from '@allianz/ng-aquila/copytext';
import { ZonemanagementComponent } from '../zonemanagement/zonemanagement.component';
import { ClientmanagementComponent } from '../clientmanagement/clientmanagement.component';
import { StatemasterComponent } from '../statemaster/statemaster.component';
import { CitymasterComponent } from '../citymaster/citymaster.component';
import { PageRoutingConfigComponent } from '../page-routing-config/page-routing-config.component';
import { TitleModule } from '../title/title.module';
import { NxCheckboxModule } from '@allianz/ng-aquila/checkbox';
import { NxHeadlineModule } from '@allianz/ng-aquila/headline';
import { NxContextMenuModule } from '@allianz/ng-aquila/context-menu';
import { ManageContentComponent } from '../manage-content/manage-content.component';
import { NxTooltipModule } from '@allianz/ng-aquila/tooltip';
import { CesstaxmasterComponent } from '../cesstaxmaster/cesstaxmaster.component';
import { NxMaskModule } from '@allianz/ng-aquila/mask';
import { NxFileUploaderModule } from '@allianz/ng-aquila/file-uploader';
import { ConfigEncryptionComponent } from '../config-encryption/config-encryption.component';
import { PortaltransactionoverviewComponent } from '../portaltransactionoverview/portaltransactionoverview.component';
import { NxRadioModule } from '@allianz/ng-aquila/radio-button';
import { NxAccordionModule } from '@allianz/ng-aquila/accordion';


@NgModule({
  declarations: [
    UserlistComponent,
    ColormanagementComponent,
    ModelmanagementComponent,
    PlanComponent,
    MasterComponent,
    PolicymasterComponent,
    ZonemanagementComponent,
    ClientmanagementComponent,
    StatemasterComponent,
    CitymasterComponent,
    PageRoutingConfigComponent,
    ManageContentComponent,
    CesstaxmasterComponent,
    ConfigEncryptionComponent,
    PortaltransactionoverviewComponent,
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    SharedModule,
    NxCardModule,
    NxLinkModule,
    NxGridModule,
    NxFormfieldModule,
    NxInputModule,
    NxDropdownModule,
    NxPopoverModule,
    NxIconModule,
    NxLabelModule,
    NxErrorModule,
    FormsModule,
    ReactiveFormsModule,
    NxButtonModule,
    NxTabsModule,
    NxTableModule,
    NxBadgeModule,
    NxSwitcherModule,
    NxModalModule,
    NxModalModule.forRoot(),
    NxDatefieldModule,
    NxNativeDateModule,
    NxMomentDateModule,
    NxSpinnerModule,
    NxPaginationModule,
    NxMessageModule,
    NxCopytextModule,
    TitleModule,
    NxCheckboxModule,
    NxHeadlineModule,
    NxContextMenuModule,
    NxTooltipModule,
    NxMaskModule,
    NxFileUploaderModule,
    NxRadioModule,
    NxAccordionModule,
  ],

  exports: [UserlistComponent, ColormanagementComponent, ModelmanagementComponent, PlanComponent, MasterComponent, PolicymasterComponent]
})
export class AdminModule { }
